import { Check } from "lucide-react";

export default function MultiChip({
  label,
  emoji,
  selected,
  onClick,
}: {
  label: string;
  emoji: string;
  selected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2.5 rounded-2xl border-2 text-[13px] transition-all duration-150 cursor-pointer ${
        selected
          ? "border-violet-500 bg-violet-50 text-violet-700 shadow-sm shadow-violet-100"
          : "border-slate-200 bg-white text-slate-700 hover:border-violet-300 hover:bg-violet-50/50"
      }`}
      style={{ fontWeight: selected ? 600 : 400 }}
    >
      <span>{emoji}</span>
      <span>{label}</span>
      {selected && <Check className="w-3.5 h-3.5 text-violet-600 ml-auto" />}
    </button>
  );
}
